import getColour from '@lendi-ui/commons/colours';
import Email from '@lendi-ui/icon/Email';

import { validateEmail } from '@funnels/utils';

import { Prefix } from '../_common/style';
import TextInputField, { TextInputFieldProps } from '.';

export const EmailInputFieldLabel = 'E-mail';
export const EmailInputFieldValidationFailMessage = 'Please enter your email address.';

const EmailInputField = (props: TextInputFieldProps) => (
  <TextInputField
    {...props}
    before={
      <Prefix>
        <Email color={getColour('fill', 'accent')} width="24px" height="24px" />
      </Prefix>
    }
    label={props.label || EmailInputFieldLabel}
    validate={validateEmail(EmailInputFieldValidationFailMessage, props.isOptional)}
  />
);

export default EmailInputField;
